import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';

@Component({
  selector: 'app-truck-group-widget-admin',
  templateUrl: './truck-group-admin.component.html',
  styleUrls: ['./truck-group-admin.component.scss']
})
export class TruckGroupAdminWidgetComponent extends AbstractWidgetComponent implements OnInit {

  constructor() {
    super()
  }

  ngOnInit() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
